<template>
  <div>
    <img :src="headerImg" />
    <div :class="showSearch ? 'header-content' : 'hide-search-header-content'">
      <BaseBackButton v-if="showButton" :text="text" :route="routeUrl" />
      <BaseSearch
        v-if="showSearch"
        :searchImgSize="14"
        :canselImgSize="20"
        @search="handleSearch"
      />
    </div>
  </div>
</template>

<script>
import BaseSearch from "@/components/common/BaseSearch.vue";
import BaseBackButton from "@/components/common/BaseBackButton.vue";
export default {
  components: {
    BaseSearch,
    BaseBackButton
  },
  props: ["headerImg", "text", "routeUrl", "showButton", "showSearch"],
  data() {
    return {
      searchQuery: ""
    };
  },
  methods: {
    // 検索ボックスのqueryを受け渡しする関数
    handleSearch(searchQuery) {
      this.$emit("handleSearchUpdate", searchQuery);
      console.log(searchQuery);
    }
  }
};
</script>

<style lang="css" scoped>
.header-content {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
}
.hide-search-header-content {
  padding: 10px;
  margin-top: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/leaders/LeadersListHeader.vue